@if (isAuthenticated$ | async) {
  <ul class="navbar-nav px-4 gap-3">
    @if (isDarkModeAllowed()) {
      <li class="nav-item">
        <lib-theme-toggle />
      </li>
    }
    <li class="nav-item">
      @if (hasRole(roles.broker) || hasRole(roles.ignite)) {
        <button
          type="button"
          class="nav-link text-dark cursor-pointer btn btn-link p-0 border-0"
          title="Share your thoughts or report an issue"
          (click)="showFeedbackModal()"
        >
          <div class="d-flex flex-column align-items-center">
            <lib-svg-icon icon="feedback" class="svg-24 text-colour-grayscale-900" [fill]="true"/>
            Give feedback
          </div>
        </button>
      }
    </li>
    <li class="nav-item">
      <div
        ngbDropdown
        display="dynamic"
        placement="bottom-right"
        class="float_right"
        title="Manage"
      >
        <div
          class="d-flex flex-column align-items-center nav-link text-dark cursor-pointer"
          id="my-account"
          ngbDropdownToggle
        >
          <lib-svg-icon icon="profile" class="svg-24 text-colour-grayscale-900" [fill]="true"/>
          <div class="d-flex gap-1 align-items-center">
            My account
            <lib-svg-icon icon="chevron-down-filled" class="svg-8-no-pad text-colour-grayscale-900" [fill]="true"/>
          </div>
        </div>
        <div
          ngbDropdownMenu
          aria-labelledby="myAccountDropdown"
        >
          @for (item of (accountMenu$ | async); track $index) {
            <button
              ngbDropdownItem
              [routerLink]="item.routerLink"
              [state]="item.state"
              [attr.data-testid]="item.label + 'Btn'"
            >
              {{ item.label }}
            </button>
          }
        </div>
      </div>
    </li>
  </ul>
} @else {
  <ul class="navbar-nav px-4 gap-3">
    @if (isDarkModeAllowed()) {
      <li class="nav-item">
        <lib-theme-toggle />
      </li>
    }
    <li class="nav-item">
      <div
        title="Register"
        class="nav-link text-dark cursor-pointer"
        [routerLink]="['/authentication/register']"
      >
        <div class="d-flex flex-column align-items-center">
          <lib-svg-icon icon="profile" class="svg-24 text-colour-grayscale-900" [fill]="true"/>
          Register
        </div>
      </div>
    </li>
    <li class="nav-item">
      <div
        title="Register"
        class="nav-link text-dark cursor-pointer"
        [routerLink]="['/authentication/login']"
      >
        <div class="d-flex flex-column align-items-center">
          <lib-svg-icon icon="sign-in" class="svg-24 text-colour-grayscale-900" [fill]="true"/>
          Log in
        </div>
      </div>
    </li>
  </ul>
}
